import {
    CLEAR_APP_VERSION_LIST,
    SET_APP_VERSION_LIST,
    APP_VERSION_CREATE_DIALOG_CLOSE,
    APP_VERSION_CREATE_DIALOG_OPEN,
    APP_VERSION_CREATE_ERROR,
    APP_VERSION_CREATE_ERROR_CLEAR,
    APP_VERSION_CREATE_PENDING,
    APP_VERSION_EDIT_DIALOG_CLOSE,
    APP_VERSION_EDIT_DIALOG_OPEN,
    APP_VERSION_EDIT_ERROR,
    APP_VERSION_EDIT_ERROR_CLEAR,
    APP_VERSION_EDIT_PENDING,
    APP_VERSION_LIST_ERROR,
    APP_VERSION_LIST_ERROR_CLEAR,
    APP_VERSION_LIST_PENDING,
    CLEAR_APP_VERSION_DETAILS,
    SET_APP_VERSION_DETAILS,
    APP_VERSION_DETAIL_PENDING,
    APP_VERSION_FILTER_DIALOG_OPEN,
    APP_VERSION_FILTER_DIALOG_CLOSE,
    SET_APP_VERSION_FILTER_DATA,
} from "./constants"

const initialState = {

    //-----------------------------|| LIST ||--------------------------------------------------------------
    appVersionList: null,
    appVersionListCount: 0,
    isAppVersionListPending: false,
    appVersionListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isAppVersionFilterDialogOpen: false,
    appVersionFilterData: null,
    //-----------------------------|| DETAIL ||-------------------------------------------------------------
    appVersionDetails: {},
    appVersionDetailsPending: false,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isAppVersionCreateDialogOpen: false,
    isAppVersionCreatePending: false,
    appVersionCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isAppVersionEditDialogOpen: false,
    isAppVersionEditPending: false,
    appVersionEditErrorMessage: null,
}

const appVersions = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||------------------------------------------------------------
        case APP_VERSION_LIST_PENDING: {
            return {
                ...state,
                isAppVersionListPending: true,
                appVersionListErrorMessage: null,
            }
        }

        case SET_APP_VERSION_LIST: {
            const { appVersionList } = action.payload || {};
            return {
                ...state,
                appVersionList: appVersionList['value'],
                appVersionListCount: appVersionList['@odata.count'],
                isAppVersionListPending: false,
                appVersionListErrorMessage: null,
            }
        }

        case APP_VERSION_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                appVersionListErrorMessage: errorMessage,
                isAppVersionListPending: false,
                appVersionList: null,
                appVersionListCount: 0,
            }
        }

        case APP_VERSION_LIST_ERROR_CLEAR: {
            return {
                ...state,
                appVersionListErrorMessage: null,
                isAppVersionListPending: false,
            }
        }
        case CLEAR_APP_VERSION_LIST: {
            return {
                ...state,
                appVersionList: null,
                appVersionListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case APP_VERSION_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isAppVersionFilterDialogOpen: true,
            }
        }
        case APP_VERSION_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isAppVersionFilterDialogOpen: false,
            }
        }

        case SET_APP_VERSION_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                appVersionFilterData: filter,
            }
        }

        //-----------------------------|| DETAILS ||--------------------------------------------------------------
        case SET_APP_VERSION_DETAILS: {
            const { appVersionDetails } = action.payload || {};
            return {
                ...state,
                appVersionDetails: appVersionDetails,
                appVersionDetailsPending: false
            }
        }
        case CLEAR_APP_VERSION_DETAILS: {
            return {
                ...state,
                appVersionDetails: {},
            }
        }
        case APP_VERSION_DETAIL_PENDING: {
            const { id } = action.payload || {};
            return {
                ...state,
                appVersionDetailsPending: id,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case APP_VERSION_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isAppVersionCreateDialogOpen: true,
            }
        }
        case APP_VERSION_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isAppVersionCreateDialogOpen: false,
            }
        }

        case APP_VERSION_CREATE_PENDING: {
            return {
                ...state,
                isAppVersionCreatePending: true,
                appVersionCreateErrorMessage: null,
            }
        }

        case APP_VERSION_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                appVersionCreateErrorMessage: errorMessage,
                isAppVersionCreatePending: false,
            }
        }

        case APP_VERSION_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                appVersionCreateErrorMessage: null,
                isAppVersionCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case APP_VERSION_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isAppVersionEditDialogOpen: true,
            }
        }
        case APP_VERSION_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isAppVersionEditDialogOpen: false,
            }
        }

        case APP_VERSION_EDIT_PENDING: {
            return {
                ...state,
                isAppVersionEditPending: true,
                appVersionEditErrorMessage: null,
            }
        }

        case APP_VERSION_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                appVersionEditErrorMessage: errorMessage,
                isAppVersionEditPending: false,
            }
        }

        case APP_VERSION_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                appVersionEditErrorMessage: null,
                isAppVersionEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default appVersions;